<template>
  <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="560px" append-to-body>
    <template slot="title">
      <div class="doc-dialog-header">
        <span>{{ dialogTitle }}</span>
        <el-button-group v-if="showViewToolbar">
          <el-button v-if="isAuth('workflow:conditionField:update')" type="primary" size="small" :disabled="actionLoading" @click="editFromView">修改</el-button>
          <el-button v-if="isAuth('workflow:conditionField:delete')" type="primary" size="small" :disabled="actionLoading" @click="deleteHandle">删除</el-button>
        </el-button-group>
      </div>
    </template>
    <el-form ref="dataForm" :model="dataForm" :rules="formRules" label-width="100px">
      <el-form-item label="单据类型" prop="bizType">
        <el-select v-model="dataForm.bizType" :disabled="formReadonly" filterable style="width:100%">
          <el-option v-for="o in bizTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="字段键" prop="fieldKey">
        <el-input v-model="dataForm.fieldKey" :disabled="formReadonly" placeholder="如 totalQuantity，须与审批上下文一致" />
      </el-form-item>
      <el-form-item label="显示名称" prop="fieldLabel">
        <el-input v-model="dataForm.fieldLabel" :disabled="formReadonly" placeholder="如 合计数量" />
      </el-form-item>
      <el-form-item label="值类型" prop="valueType">
        <el-select v-model="dataForm.valueType" :disabled="formReadonly" style="width:100%">
          <el-option v-for="o in valueTypeOptions" :key="o.value" :label="o.label" :value="o.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="dataForm.lineSort" :disabled="formReadonly" :min="0" :max="9999" style="width:100%" />
      </el-form-item>
      <el-form-item label="启用">
        <el-switch v-model="dataForm.enabled" :disabled="formReadonly" active-value="1" inactive-value="0" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="dataForm.remark" :disabled="formReadonly" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">{{ formReadonly ? '关闭' : '取消' }}</el-button>
      <el-button v-if="!formReadonly" type="primary" :loading="actionLoading" @click="submitHandle">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import request from '../../api/request'
import auth from './workflowAuth'

const VALUE_TYPES = [
  { value: 'number', label: '数字' },
  { value: 'dept', label: '部门' },
  { value: 'user', label: '用户' },
  { value: 'text', label: '文本' }
]

function blank() {
  return { fieldId: '', bizType: '', fieldKey: '', fieldLabel: '', valueType: 'text', lineSort: 10, enabled: '1', remark: '' }
}

export default {
  mixins: [auth],
  props: { bizTypeOptions: { type: Array, default: () => [] } },
  data() {
    return {
      visible: false,
      readonly: false,
      actionLoading: false,
      valueTypeOptions: VALUE_TYPES,
      dataForm: blank(),
      dataRule: {
        bizType: [{ required: true, message: '请选择单据类型', trigger: 'change' }],
        fieldKey: [{ required: true, message: '字段键不能为空', trigger: 'blur' }],
        fieldLabel: [{ required: true, message: '显示名称不能为空', trigger: 'blur' }],
        valueType: [{ required: true, message: '请选择值类型', trigger: 'change' }]
      }
    }
  },
  computed: {
    formReadonly() { return this.readonly },
    showViewToolbar() { return this.readonly && !!this.dataForm.fieldId },
    dialogTitle() {
      if (this.readonly) return '查看条件字段'
      return this.dataForm.fieldId ? '修改条件字段' : '新增条件字段'
    },
    formRules() { return this.formReadonly ? {} : this.dataRule }
  },
  methods: {
    init(id, readonly) {
      this.readonly = !!readonly
      this.dataForm = blank()
      this.visible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      if (!id) return
      request.get('/workflow/conditionField/info/' + id).then(res => {
        const row = res.data || {}
        this.dataForm = Object.assign(blank(), row, { lineSort: Number(row.lineSort || 0), enabled: row.enabled == null ? '1' : String(row.enabled) })
        this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
      }).catch(() => {})
    },
    editFromView() {
      this.readonly = false
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    submitHandle() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.actionLoading = true
        const update = !!this.dataForm.fieldId
        request.post('/workflow/conditionField/' + (update ? 'update' : 'save'), this.dataForm).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      })
    },
    deleteHandle() {
      this.$confirm('确定删除该条件字段?', '提示', { type: 'warning' }).then(() => {
        this.actionLoading = true
        request.post('/workflow/conditionField/delete', { fieldId: this.dataForm.fieldId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.$emit('refreshDataList')
        }).catch(() => {}).finally(() => { this.actionLoading = false })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
</style>
